import { render, staticRenderFns } from "./dissect.vue?vue&type=template&id=0956c788&scoped=true"
import script from "./dissect.vue?vue&type=script&lang=js"
export * from "./dissect.vue?vue&type=script&lang=js"
import style0 from "./dissect.vue?vue&type=style&index=0&id=0956c788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0956c788",
  null
  
)

export default component.exports